/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "nxApiAuth",
            "endpoint": "https://kfjx6zh7qd.execute-api.eu-central-1.amazonaws.com/main",
            "region": "eu-central-1"
        },
        {
            "name": "nxApiUsers",
            "endpoint": "https://oa88lfj6w5.execute-api.eu-central-1.amazonaws.com/main",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:34effd94-b83b-45c5-a9eb-f38c033f4b75",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_uUJAhg79P",
    "aws_user_pools_web_client_id": "np8jqn4v6mkt2gbu13kc281iu",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "UPDATED_AT",
        "PHONE_NUMBER",
        "EMAIL",
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "nxDBUsers-main",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
